import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import { motion } from 'framer-motion';
import { FaStar, FaQuoteLeft } from 'react-icons/fa';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './Testimonials.css';

const TestimonialSection = () => {
  const testimonials = [
    {
      id: 1,
      name: "Rajesh Kumar",
      role: "Software Engineer, Bangalore",
      company: "Tech Mahindra",
      text: "I tried Early stage feature of F2F Lending, It's unique in market and it will really be helpful for efficient transactions between colleagues.",
      rating: 5,
      avatar: "👨‍💻",
    },
    {
      id: 2,
      name: "Priya Sharma",
      role: "College Student, Delhi",
      company: "Delhi University",
      text: "The group fund feature saved our travel plans. We collected money for Goa trip without any hassle. Since the app is not live, we have used Beta version from a friend who shared the link.",
      rating: 5,
      avatar: "👩‍🎓",
    },
    {
      id: 3,
      name: "Neha Gupta",
      role: "Marketing Manager, Mumbai",
      company: "HDFC Bank",
      text: "Bill splitting with friends used to be stressful. Now it's automated and transparent. We settle group expenses instantly. Love the smart reminders!",
      rating: 5,
      avatar: "👩‍💼",
    },
    {
      id: 4,
      name: "Vikram Singh",
      role: "Office Team Lead, Pune",
      company: "Infosys",
      text: "Wow such an amazing platform. F2F Lending features and Community Borrowing is something very unique. You guys will grow exponentially.",
      rating: 5,
      avatar: "👨‍💼",
    },
    {
      id: 5,
      name: "Suresh Menon",
      role: "Small Business Owner, Kerala",
      company: "Local Grocery Store",
      text: "Highly recommended! Amazing platform solving a real world issue.",
      rating: 5,
      avatar: "👨‍💼",
    },
    {
      id: 6,
      name: "Meera Desai",
      role: "Homemaker & Community Leader, Ahmedabad",
      company: "Women's Self Help Group",
      text: "Explored the features of the application. Mark my words, it's going to be revolutionary.",
      rating: 5,
      avatar: "👩‍⚖️",
    }
  ];

  return (
    <section className="testimonials-section" id="testimonials">
      <div className="container">

        {/* Section header */}
        <div className="section-header">
          <motion.h2
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            Tested by 200+ Indians at Beta Testing Phase
          </motion.h2>
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.1 }}
            viewport={{ once: true }}
            className="section-subtitle"
          >
            Join the revolution of social finance. See what our community says about
            transforming their financial relationships.
          </motion.p>
        </div>

        {/* Slider */}
        <motion.div
          className="testimonials-container"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
          viewport={{ once: true }}
        >
          <Swiper
            modules={[Pagination, Autoplay, Navigation]}
            spaceBetween={24}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true, dynamicBullets: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false, pauseOnMouseEnter: true }}
            breakpoints={{
              640:  { slidesPerView: 1 },
              768:  { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 3 }
            }}
            className="testimonials-slider"
          >
            {testimonials.map((t, idx) => (
              <SwiperSlide key={t.id}>
                <motion.div
                  className="testimonial-card"
                  initial={{ opacity: 0, scale: 0.95 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.4, delay: idx * 0.08 }}
                  whileHover={{ y: -6 }}
                >
                  <div className="testimonial-header">
                    <div className="testimonial-avatar">{t.avatar}</div>
                    <div className="testimonial-info">
                      <h4>{t.name}</h4>
                      <p className="testimonial-role">{t.role}</p>
                      <p className="testimonial-company">{t.company}</p>
                    </div>
                  </div>

                  <FaQuoteLeft className="quote-icon" />

                  <p className="testimonial-text">{t.text}</p>

                  <div className="testimonial-rating">
                    {[...Array(5)].map((_, i) => (
                      <FaStar
                        key={i}
                        className={i < t.rating ? 'star-filled' : 'star-empty'}
                      />
                    ))}
                    <span className="rating-text">{t.rating}.0/5</span>
                  </div>
                </motion.div>
              </SwiperSlide>
            ))}
          </Swiper>
        </motion.div>

      </div>
    </section>
  );
};

export default TestimonialSection;
